import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
import { DPI_DETAILS, } from "@frameworks/web/redux/interfaces/Reports/iDpInterest";
const DpDetailsReducer = (state, action) => {
    switch (action.type) {
        case DPI_DETAILS:
            return Object.assign(Object.assign({}, state), { dpiDetails: action.payload.dpiDetails });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: DpDetailsReducer,
    commonData: commonOnePlatFormReducer,
});
